import axios from "axios";
import { reportApiError } from "./reportError";

const request = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_SERVER_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 120000,
  validateStatus(status) {
    return status >= 200 && status < 300;
  },
});

// Every API call in the dashboard goes through this instance — directly from
// Home.vue, and via swrGet from Leaderboard, MapView and TeamFilter. So this is
// the one place that can see every failure, including any call site added
// later without anyone having to remember.
//
// The existing per-site catch handlers are left exactly as they are: this only
// adds reporting, and always rethrows, so behaviour is unchanged. Which
// failures are worth reporting is decided in ./reportError.
request.interceptors.response.use(
  (response) => response,
  (error) => {
    reportApiError(error);
    return Promise.reject(error);
  }
);

export default request;
